import React, { useState, useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { useNavigate } from 'react-router-dom';

function Home() {
  const [teamData, setTeamData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const [showInstallModal, setShowInstallModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadTeamData();
  }, []);

  const loadTeamData = async () => {
    try {
      const teamDoc = await getDoc(doc(db, 'teams', auth.currentUser.uid));
      if (teamDoc.exists()) {
        setTeamData(teamDoc.data());
      }
    } catch (error) {
      console.error('Error loading team:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Show install banner after first vote
    if (teamData) {
      const totalVotes = teamData?.votes?.length || 0;
      const hasSeenPrompt = localStorage.getItem('installPromptDismissed');
      const isInstalled = window.matchMedia('(display-mode: standalone)').matches;
      
      if (totalVotes === 1 && !hasSeenPrompt && !isInstalled) {
        setShowInstallBanner(true);
      }
    }
  }, [teamData]);

  const handleLogout = async () => {
    await signOut(auth);
  };

  const dismissInstallBanner = () => {
    setShowInstallBanner(false);
    localStorage.setItem('installPromptDismissed', 'true');
  };

  const needsSetup = !teamData?.players || teamData.players.length === 0;
  const totalVotes = teamData?.votes?.length || 0;
  const isInstalled = window.matchMedia('(display-mode: standalone)').matches;

  if (loading) {
    return (
      <div className="container">
        <div className="header" style={{ justifyContent: 'center', padding: '8px 20px' }}>
          <img 
            src="/PitchalloMOTM.png" 
            alt="Pitchallo-motm" 
            style={{ 
              height: '250px',
              objectFit: 'contain',
              maxWidth: '90%'
            }}
          />
        </div>
        <p style={{ textAlign: 'center', padding: '40px' }}>Loading...</p>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="header" style={{ justifyContent: 'center', padding: '8px 20px' }}>
        <img 
          src="/PitchalloMOTM.png" 
          alt="Pitchallo-motm" 
          style={{ 
            height: '250px',
            objectFit: 'contain',
            maxWidth: '90%'
          }}
        />
      </div>
      
      <div style={{ textAlign: 'right', padding: '4px 20px 8px 20px' }}>
        <button 
          onClick={handleLogout}
          style={{
            background: 'none',
            border: 'none',
            color: '#243665',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Logout
        </button>
      </div>

      {/* Install Banner - Shows after first vote */}
      {showInstallBanner && (
        <div style={{
          background: '#243665',
          color: 'white',
          padding: '16px 20px',
          margin: '0 20px 20px 20px',
          borderRadius: '12px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <div style={{ flex: 1 }}>
            <p style={{ fontWeight: 'bold', marginBottom: '4px', fontSize: '14px' }}>
              🎉 Great! You've cast your first vote
            </p>
            <p style={{ fontSize: '12px', opacity: 0.9, marginBottom: 0 }}>
              Add MOTM to your home screen for quick access
            </p>
          </div>
          <div style={{ display: 'flex', gap: '8px', marginLeft: '12px' }}>
            <button
              onClick={() => setShowInstallModal(true)}
              style={{
                background: 'white',
                border: 'none',
                color: '#243665',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '600',
                whiteSpace: 'nowrap'
              }}
            >
              How
            </button>
            <button
              onClick={dismissInstallBanner}
              style={{
                background: 'rgba(255,255,255,0.2)',
                border: 'none',
                color: 'white',
                padding: '8px 12px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '13px'
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* Install Instructions Modal */}
      {showInstallModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '20px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: '28px',
            maxWidth: '400px',
            width: '100%',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
          }}>
            <h3 style={{ marginBottom: '16px', color: '#243665', fontSize: '20px' }}>
              📱 Install MOTM
            </h3>
            <p style={{ fontSize: '14px', marginBottom: '20px', color: '#666' }}>
              Add MOTM to your home screen for quick access and the best experience:
            </p>
            
            {/* iOS Instructions - CORRECTED */}
            <div style={{ 
              background: '#f5f5f5', 
              padding: '16px', 
              borderRadius: '8px',
              marginBottom: '12px'
            }}>
              <p style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '14px', color: '#243665' }}>
                iPhone/iPad (Safari):
              </p>
              <ol style={{ fontSize: '13px', lineHeight: '1.7', paddingLeft: '20px', margin: 0 }}>
                <li>Tap the <strong>menu</strong> button <span style={{ fontSize: '16px' }}>⋯</span> (three dots at bottom right)</li>
                <li>Tap the <strong>Share</strong> button <span style={{ fontSize: '16px' }}>↗️</span> (arrow coming out of box)</li>
                <li>Scroll down and tap <strong>"Add to Home Screen"</strong></li>
                <li>Tap <strong>"Add"</strong> in the top right</li>
              </ol>
            </div>

            {/* Android Instructions */}
            <div style={{ 
              background: '#f5f5f5', 
              padding: '16px', 
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <p style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '14px', color: '#243665' }}>
                Android (Chrome):
              </p>
              <ol style={{ fontSize: '13px', lineHeight: '1.7', paddingLeft: '20px', margin: 0 }}>
                <li>Tap the <strong>menu</strong> <span style={{ fontSize: '16px' }}>⋮</span> (three dots at top right)</li>
                <li>Tap <strong>"Add to Home screen"</strong> or <strong>"Install app"</strong></li>
                <li>Tap <strong>"Add"</strong></li>
              </ol>
            </div>

            <button
              onClick={() => {
                setShowInstallModal(false);
                dismissInstallBanner();
              }}
              className="button"
              style={{ width: '100%' }}
            >
              Got it!
            </button>
          </div>
        </div>
      )}

      <div style={{ padding: '20px 0' }}>
        <div className="card">
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: 'bold', 
            color: '#243665',
            marginBottom: '4px'
          }}>
            {teamData?.teamName || 'Your Team'}
          </h2>
          <p style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
            Coach: {teamData?.coachName}
          </p>
          <p style={{ fontSize: '13px', color: '#999', marginBottom: '16px' }}>
            {teamData?.clubName} • {teamData?.clubLocation}
          </p>
          
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-around',
            paddingTop: '16px',
            borderTop: '1px solid #eee'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                fontSize: '32px', 
                fontWeight: 'bold', 
                color: '#243665' 
              }}>
                {teamData?.players?.length || 0}
              </div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                Players
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                fontSize: '32px', 
                fontWeight: 'bold', 
                color: '#243665' 
              }}>
                {totalVotes}
              </div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                Rounds
              </div>
            </div>
          </div>
        </div>

        {needsSetup && (
          <div className="card" style={{ background: '#fff3cd', borderLeft: '4px solid #856404' }}>
            <p style={{ fontWeight: 'bold', color: '#856404', marginBottom: '4px' }}>
              ⚠️ Setup Required
            </p>
            <p style={{ fontSize: '14px', color: '#856404' }}>
              Click Manage Team to add your players so you can start recording votes.
            </p>
          </div>
        )}

        <div>
          <button
            className="button"
            onClick={() => navigate('/vote')}
            disabled={needsSetup}
          >
            🗳️ Vote 3-2-1
          </button>

          <button
            className="button button-outline"
            onClick={() => navigate('/leaderboard')}
            disabled={needsSetup || totalVotes === 0}
          >
            🏆 View Leaderboard
          </button>

          <button
            className="button button-outline"
            onClick={() => navigate('/history')}
            disabled={totalVotes === 0}
          >
            📜 Round History
          </button>

          <button
            className="button button-outline"
            onClick={() => navigate('/team-setup')}
          >
            👥 Manage Team
          </button>

          <button
            className="button button-outline"
            onClick={() => {
              const message = encodeURIComponent('Check out Pitchallo-motm.com - the easiest way to track player votes for grassroots sports teams! ' + window.location.origin);
              
              const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
              const smsUrl = isIOS 
                ? `sms:&body=${message}`
                : `sms:?body=${message}`;
              
              window.location.href = smsUrl;
            }}
          >
            💬 Share via SMS
          </button>

          {/* Manual Install Button - Always available */}
          {!isInstalled && (
            <button
              className="button button-outline"
              onClick={() => setShowInstallModal(true)}
              style={{ 
                background: 'white',
                color: '#243665',
                border: '2px dashed #243665'
              }}
            >
              📱 How to Install App
            </button>
          )}
        </div>

        <div className="pitchallo-footer" style={{ marginTop: '40px' }}>
          {/* Subtle footer tip - always visible */}
          {!isInstalled && (
            <p style={{ fontSize: '13px', color: '#999', marginBottom: '12px' }}>
              💡 Add MOTM to your home screen for the best experience
            </p>
          )}
          <p style={{ marginBottom: '12px' }}>
            Love Pitchallo-motm? Try Pitchallo.com for scheduling
          </p>
          <a href="https://pitchallo.com" target="_blank" rel="noopener noreferrer">
            Learn More About Pitchallo →
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;
